<form [formGroup]="form">
    <div class="row justify-content-start">
        @for (day of schedule; track day; let i = $index; let last = $last) {
            <div class="col-auto">
                <app-time-picker-day
                    [index]="i"
                    [dayOfWeek]="getDayOfTheWeek(i) | messageTranslate"
                    [schedule]="day"
                    (formReady)="addScheduleFormControl(i, last, $event)"
                    (copiedSchedule)="copyDaySchedule($event)"
                    [readonly]="readonly"/>
            </div>
        }
    </div>
</form>
